import React from "react";

const FEATURES = [
  {
    icon: (
      <svg
        viewBox="0 0 64 64"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="10" y="14" width="44" height="32" rx="4" />
        <path d="M10 22 H54" />
        <circle cx="16" cy="18" r="1.5" fill="currentColor" />
        <circle cx="22" cy="18" r="1.5" fill="currentColor" />
        <path d="M18 32 H30" />
        <path d="M18 38 H38" />
        <path d="M44 30 L44 36 M40 33 L48 33" />
      </svg>
    ),
    title: "No-Code Customisable",
    body:
      "Educators tailor Prof. E end-to-end — set learning objectives, tone, response style, custom starter questions and what students reflect on. No engineering required.",
  },
  {
    icon: (
      <svg
        viewBox="0 0 64 64"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M10 50 V20 L20 14 L30 20 L40 14 L50 20 L54 18 V44 L50 46 L40 40 L30 46 L20 40 L10 50 z" />
        <path d="M20 14 V40" />
        <path d="M30 20 V46" />
        <path d="M40 14 V40" />
      </svg>
    ),
    title: "AI Summarisation & Insight Dashboard",
    body:
      "Analyse hundreds of reflections through your own thematic rubrics. Generate clear summaries of student thinking, sentiment, common themes and learning gaps — qualitative data turned action-ready.",
  },
  {
    icon: (
      <svg
        viewBox="0 0 64 64"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="32" cy="32" r="20" />
        <path d="M32 20 V32 L40 38" />
        <path d="M32 8 V12" />
        <path d="M32 52 V56" />
        <path d="M8 32 H12" />
        <path d="M52 32 H56" />
      </svg>
    ),
    title: "Real-Time Feedback at Scale",
    body:
      "Students get personalised feedback that deepens reflection and encourages critical thinking. Teachers save time. Admin teams get structured analytics — across schools or faculties.",
  },
];

const ProfEFeatures: React.FC = () => (
  <section className="pe-section pe-section--cyan pe-features">
    <div className="pe-container">
      <div className="pe-features__heading">
        <div className="pe-eyebrow">Features &amp; Functions</div>
        <h2 className="pe-features__h">Everything Behind the Scene</h2>
        <p className="pe-features__sub">
          Prof. E runs on a frontier LLM (GPT-4o by default; Gemini and DeepSeek are swap-in options).
          What it does with that model is what matters.
        </p>
      </div>
      <div className="pe-features__grid">
        {FEATURES.map((f) => (
          <div className="pe-feature-card" key={f.title}>
            <div className="pe-feature-card__icon">{f.icon}</div>
            <h3 className="pe-feature-card__title">{f.title}</h3>
            <p className="pe-feature-card__body">{f.body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ProfEFeatures;
